import { render, staticRenderFns } from "./AiSettingsDialog.vue?vue&type=template&id=673aaaf5&scoped=true&"
import script from "./AiSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./AiSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AiSettingsDialog.vue?vue&type=style&index=0&id=673aaaf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673aaaf5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
